import { ClientList } from '@src/clients/domain/Client';
import { ClientsClient } from '@src/clients/services/ClientsClient';
import { useQuery } from '@tanstack/react-query';

export const useClients = () => {
  const { data: clientList = new ClientList([]), isLoading } =
    useQuery<ClientList>({
      queryKey: ['clients.list'],
      queryFn: () => ClientsClient.list(),
    });

  return {
    isLoading,
    clientList,
  };
};
